// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"d849a2fec17f659aa696","453":"33efd7ee076071f5e022","454":"dee3075e41d6d43cdb3c"}[chunkId] + ".js";
};